document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll("video");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play();
          console.log("play");
        } else {
          video.pause();
          console.log("pause");
        }
      });
    },
    {
      threshold: 0.9 
    }
  );

  videos.forEach((video) => {
    video.autoplay = false; 
    video.pause();          
    observer.observe(video);
  });

  $('a[href="#"]').on('click', function(e) {
  e.preventDefault(); // prevents default anchor behavior
});
  
});

